import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { DEFAULT_BUTTON_CONFIG } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import { stopJingle } from '../SoundManager';
import UIAssetKeys from '../UIAssetKeys';
import IntroScreen from './IntroScreen';
import FontKeys from '../FontKeys';

export default class EndScreen extends Phaser.Scene {
  static get KEY() { return 'EndScreen'; }

  constructor() {
    super({ key: EndScreen.KEY });
  }

  create() {
    const image = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._bonus_background, this).setOrigin(0);

    this.title = ABCyaPhaser.Text.addCurvedText(this.scale.width / 2, -200, 115, 0xff5500, FontKeys._dimboregular, ABCyaPhaser.Localization.instance.getLocalizedString('end_screen.congratulations'), 2000, this,-90 * Phaser.Math.DEG_TO_RAD, null, null, true).setVisible(false);
    this.title.y += this.title.radius;
    this.title.letterTextFields.forEach(letter => letter.setShadow(0, 8, '#00000060'));

    ABCyaPhaser.Tweens.addTween(this.title, 1400, { delay: 700, y: 80 + this.title.radius, onStart: () => this.title.setVisible(true) }, Phaser.Math.Easing.Bounce.Out);

    this.subtitle = ABCyaPhaser.Text.addText(this.scale.width / 2, -200, 70, 0xffffff, FontKeys._cloudy_with_a_chance_of_lovRg, ABCyaPhaser.Localization.instance.getLocalizedString('end_screen.you_found_your_cat'), this, true).setVisible(false)
      .setStroke('#ff5500', 6)
      .setResolution(1.5)
      .setPadding(4,4);
    ABCyaPhaser.Tweens.addTween(this.subtitle, 1400, { delay: 1100, y: this.subtitle.y + 420, onStart: () => this.subtitle.setVisible(true) }, Phaser.Math.Easing.Bounce.Out);

    this.button = ABCyaPhaser.Buttons.addDefaultButton(this.scale.width / 2 + 350, this.scale.height / 2 + 130, UIAssetKeys._play_again_button, null, SoundAssetKeys._click, this.transitionOut.bind(this), this, { ...DEFAULT_BUTTON_CONFIG });
    this.button.scale = 0;
    ABCyaPhaser.Tweens.addTween(this.button, 500, { delay: 700, scale: 1 }, Phaser.Math.Easing.Bounce.Out, () => this.loopButton());

    this.cameras.main.zoom = 0;
    this.transitionIn();
  }

  transitionIn () {
    const totalRotation = 2 * 360;
    this.tweens.add({ targets: { value: 0 },
      duration: 700,
      ease: Phaser.Math.Easing.Linear,
      props: { value: 1 },
      onUpdate: (tween, target) => {
        this.cameras.main.setAngle(target.value * totalRotation);
      } });
    ABCyaPhaser.Tweens.addTween(this.cameras.main,700, { zoom: 1 }, Phaser.Math.Easing.Linear);
  }

  transitionOut () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._transition, this);

    const totalRotation = -2 * 360;
    this.tweens.add({ targets: { value: 0 },
      duration: 700,
      ease: Phaser.Math.Easing.Linear,
      props: { value: 1 },
      onUpdate: (tween, target) => {
        this.cameras.main.setAngle(target.value * totalRotation);
      } });
    ABCyaPhaser.Tweens.addTween(this.cameras.main,700, { zoom: 0 }, Phaser.Math.Easing.Linear, () => this.cleanUp());
  }

  loopButton () {
    ABCyaPhaser.Tweens.addTween(this.button, 800, { scale: 1.1 }, Phaser.Math.Easing.Bounce.Out, () => {
      ABCyaPhaser.Tweens.addTween(this.button, 800, { scale: 1 }, Phaser.Math.Easing.Bounce.Out, () => {
        this.loopButton();
      });
    });
  }

  cleanUp () {
    stopJingle();
    this.tweens.killAll();
    this.time.clearPendingEvents();
    this.time.removeAllEvents();
    this.scene.start(IntroScreen.KEY);
  }
}